import INavBar from "@component/INavBar";
import React, {useState} from "react";
import {getItemObj} from "@util/store";

import "@src/assets/style/forgot.scss"
import {Button, Form, Input} from "antd-mobile";
import CommonService from "@service/commonService";
import {Toast} from "antd-mobile-v2";
import {isEmpty} from "@src/util";
import {Md5} from "ts-md5";
import {goto} from "@src/route";

export default function () {

    const [mode, setMode] = useState<'code' | 'pwd'>('code')
    const [code, setCode] = useState<string | undefined>();

    return <>
        <INavBar title="身份验证" isRight isBack={true}/>
        <div className="content">
            <div className="forgot-form">
                {
                    mode == 'pwd' ? <PasswordForm/> : <CodeForm onNext={(code) => {
                        setCode(code)
                        setMode('pwd')
                    }}/>
                }
            </div>
        </div>
    </>
}

function CodeForm(props: { onNext: (code: string) => void }) {
    const {onNext} = props;
    const {phone} = getItemObj('userInfo')
    const [count, setCount] = useState<number>(0)
    let sending = false;
    let interval: any

    function sendCode() {
        // 发送验证码
        if (count > 0 || sending) return
        let _c = 59;
        sending = true;
        CommonService.sendPWDCode(phone).then(rs => {
            interval = setInterval(() => {
                if (_c <= 0) {
                    clearInterval(interval)
                    setCount(0)
                    sending = false
                    return
                }
                setCount(--_c)
            }, 1000)
        }).catch(() => {
            Toast.show('验证码发送失败，请重新发送')
            setCount(0)
            sending = false
        })
    }

    return <Form layout="horizontal"
                 onFinish={(c) => {
                     const code = c.code;
                     if (!isEmpty(code)) {
                         CommonService.validatePWDCode(phone, code).then(rs => {
                             onNext(code)
                         }).catch(e => {
                             Toast.show(e)
                         })
                     }
                 }}
                 footer={
                     <Button block type="submit" className="submit-btn" size="middle">下一步</Button>
                 }
    >
        <Form.Item label="手机号">{phone && phone.replace(/(\d{3})\d{4}(\d{4})/,'$1****$2')}</Form.Item>
        <Form.Item name="code"
                   style={{marginTop: '10px'}}
                   extra={
                       <div className={count == 0 ? "code-send-btn" : "code-send-btn disable"}
                            onClick={() => sendCode()}
                       >
                           {count > 0 ? `重新获取(${count})` : '获取验证码'}
                       </div>
                   }
        >
            <Input placeholder="短信验证码"/>
        </Form.Item>
    </Form>
}


function PasswordForm(props: { code?: string }) {
    const {code} = props;

    function onSubmit(v: any) {
        if (isEmpty(v.pwd)) {
            Toast.show('请填写完整密码')
            return;
        }
        if (isEmpty(v.pwd2)) {
            Toast.show('请再次输入新密码')
            return;
        }

        if (v.pwd !== v.pwd2) {
            Toast.show('两次密码不一致')
            return;
        }

        if (v.pwd.length > 16) {
            Toast.show('密码格式有误')
            return;
        }

        const _p = Md5.hashStr(v.pwd);
        CommonService.changePwd(_p).then(rs => {
            goto('/')
        }).catch(e => {
            Toast.show(e)
        })
    }

    return <Form layout="horizontal"
                 onFinish={(v) => {
                     onSubmit(v)
                 }}
                 footer={
                     <Button block type="submit" className="submit-btn" size="middle">确认</Button>
                 }
    >
        <Form.Item label="输入新密码" name="pwd"><Input type="password" maxLength={16}
                                                   placeholder="请输入密码，最长16位"/></Form.Item>
        <Form.Item label="再次输入密码" name="pwd2"><Input type="password" maxLength={16}
                                                     placeholder="请输入密码，最长16位"/></Form.Item>
    </Form>
}
